/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { db } from "../config/firebaseConfig";
import { UserAuth } from "../context/authContext";
import FirestoreTimestampToDate from "./utils/FirebaseTimetoDate";

const MyTransaction = () => {
  const [id, setId] = useState(localStorage.getItem("roomId") || "");
  const [transactions, setTransactions] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filter, setFilter] = useState("hash");
  const { user } = UserAuth();

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleFilterChange = (e) => {
    setFilter(e.target.value);
  };

  useEffect(() => {
    const fetchMyTransactions = async () => {
      if (!user?.email) return;

      try {
        const transactionsCollection = db
          .collection("rooms")
          .doc(id)
          .collection("transactions");

        const snapshot = await transactionsCollection.get();
        const transactionsData = snapshot.docs
          .map((doc) => ({
            ...doc.data(),
            timestamp: FirestoreTimestampToDate(doc.data().timestamp),
            id: doc.id,
          }))
          .filter((transaction) => transaction.senderEmail === user.email); // Filter by current user

        setTransactions(transactionsData);
      } catch (error) {
        console.error("Error fetching transactions:", error);
      }
    };

    if (id && user?.email) {
      fetchMyTransactions();
    }
  }, [id, user?.email]);

  const filteredTransactions = transactions.filter((transaction) => {
    if (!searchTerm) return true; // Show all if no search term

    try {
      if (filter === "hash") {
        return transaction.id?.toLowerCase().includes(searchTerm.toLowerCase());
      } else if (filter === "sender") {
        return transaction.sender
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase());
      } else if (filter === "receiver") {
        return transaction.receiver
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase());
      } else if (filter === "status") {
        return transaction.status
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase());
      } else if (filter === "timestamp") {
        return transaction.timestamp
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase());
      } else if (filter === "amount") {
        return transaction.amount?.toString().includes(searchTerm);
      }
    } catch (error) {
      console.error("Filter error:", error);
      return false;
    }
    return false;
  });

  const renderTrimmedAddress = (address) =>
    `${address?.substring(0, 10) || ""}...`;

  return (
    <section className="min-h-screen pt-10 pb-8 px-6">
      <div className="max-w-7xl mx-auto text-white">
        <h1 className="text-2xl font-bold text-white mb-6">My Transactions</h1>

        {/* Search and Filter */}
        <div className="flex gap-4 mb-6">
          <div className="flex-1 relative">
            <input
              type="text"
              value={searchTerm}
              onChange={handleSearchChange}
              placeholder="Search your transactions..."
              className="w-full bg-[#343B4F]/60 border border-white/10 rounded-lg px-4 py-3 text-white text-sm outline-none focus:border-[#6C4FFF] transition"
            />
          </div>
          <select
            value={filter}
            onChange={handleFilterChange}
            className="bg-[#343B4F]/60 border border-white/10 rounded-lg px-4 py-3 text-white text-sm outline-none focus:border-[#6C4FFF] transition cursor-pointer"
          >
            <option value="hash">Transaction ID</option>
            <option value="sender">Sender</option>
            <option value="receiver">Receiver</option>
            <option value="status">Status</option>
            <option value="timestamp">Timestamp</option>
            <option value="amount">Amount</option>
          </select>
        </div>

        {/* Transactions Table */}
        <div className="bg-[#343B4F]/60 backdrop-blur rounded-xl p-8 border border-white/10 overflow-x-auto">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-white/10">
                  <th className="text-left text-white/60 text-sm font-semibold pb-4 px-4">
                    Transaction ID
                  </th>
                  <th className="text-left text-white/60 text-sm font-semibold pb-4 px-4">
                    Sender
                  </th>
                  <th className="text-left text-white/60 text-sm font-semibold pb-4 px-4">
                    Receiver
                  </th>
                  <th className="text-left text-white/60 text-sm font-semibold pb-4 px-4">
                    Status
                  </th>
                  <th className="text-left text-white/60 text-sm font-semibold pb-4 px-4">
                    Timestamp
                  </th>
                  <th className="text-left text-white/60 text-sm font-semibold pb-4 px-4">
                    Amount
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredTransactions && filteredTransactions.length > 0 ? (
                  filteredTransactions.map((transaction, index) => (
                    <tr
                      key={index}
                      className="border-b border-white/5 hover:bg-white/5"
                    >
                      <td className="py-4 px-4 text-white text-sm font-mono">
                        {transaction.id}
                      </td>
                      <td className="py-4 px-4 text-white text-sm font-mono">
                        {renderTrimmedAddress(transaction.sender)}
                      </td>
                      <td className="py-4 px-4 text-white text-sm font-mono">
                        {renderTrimmedAddress(transaction.receiver)}
                      </td>
                      <td className="py-4 px-4">
                        <span
                          className={`px-3 py-1 rounded-full text-xs font-semibold ${
                            transaction.status === "Verified"
                              ? "bg-green-500/20 text-green-400"
                              : "bg-yellow-500/20 text-yellow-400"
                          }`}
                        >
                          {transaction.status}
                        </span>
                      </td>
                      <td className="py-4 px-4 text-white text-sm">
                        {transaction.timestamp}
                      </td>
                      <td className="py-4 px-4 text-white text-sm font-semibold">
                        {transaction.amount}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="py-8 text-center text-white/60">
                      No Transactions Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MyTransaction;
